module.exports = __webpack_public_path__ + "img/kaoqin.d1c76c7b.jpg";